import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import PropTypes from "prop-types";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";
import { isLessThanDay } from "../../../assets/jss/util/validateUtil";

const Capnhatdonvi = React.memo(function Capnhatdonvi(props) {
  const { donvi_id } = props;
  const [loaihinhvantai, setLoaihinhvantai] = React.useState([]);
  const [loaihinhvalue, setLoaihinhvalue] = React.useState([]);
  const [tendonvi, setTendonvi] = React.useState("");
  const [sonha, setSonha] = React.useState("");
  const [diachidonvi, setDiachidonvi] = React.useState("");
  const [sodienthoai, setSodienthoai] = React.useState("");
  const [giayphepdkkd, setGiayphepdkkd] = React.useState("");
  const [ngaycapgpdkkd, setNgaycapgpdkkd] = React.useState(dayjs());
  const [coquancap, setCoquancap] = React.useState("");
  const [nguoidaidien, setNguoidaidien] = React.useState("");
  const [sogiayphep, setSogiayphep] = React.useState("");
  const [xa, setXa] = React.useState([]);
  const [xavalue, setXavalue] = React.useState(null);
  const [xaten, setXaten] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [ngaycapgpkdvt, setNgaycapgpkdvt] = React.useState(dayjs());
  const [ngayhethangpkdvt, setNgayhethangpkdvt] = React.useState(null);
  const [nguoidieuhanh, setNguoidieuhanh] = React.useState("");
  const [hoatdong, setHoatdong] = React.useState(1);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getdonvitheoid = () => {
    var url =
      Config.backend +
      "/api/Donvi/getdonvitheoid?id=" +
      donvi_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTendonvi(data[0].tendonvi);
        setSonha(data[0].sonha);
        if (data[0].sonha) {
          setDiachidonvi(data[0].sonha + "," + data[0].tenphuongxa);
        } else {
          setDiachidonvi(data[0].tenphuongxa);
        }
        setGiayphepdkkd(data[0].giayphepdkkd);
        setCoquancap(data[0].coquancap);
        setSodienthoai(data[0].sodienthoai);
        setNguoidaidien(data[0].nguoidaidien);
        setSogiayphep(data[0].sogiayphep);
        setNguoidieuhanh(data[0].nguoidieuhanh);
        setXavalue({ id: data[0].phuongxa_id, ten: data[0].tenphuongxa });
        setXaten(data[0].tenphuongxa);
        setNgaycapgpdkkd(dayjs(data[0].ngaycapgpdkkd));
        setNgaycapgpkdvt(dayjs(data[0].ngaycapgpkdvt));
        if (data[0].ngayhethangpkdvt) {
          setNgayhethangpkdvt(dayjs(data[0].ngayhethangpkdvt));
        }
        setHoatdong(data[0].hoatdong);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getloaihinhvantai = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmloaihinhvantaiall?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaihinhvantai(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getxaphuong = () => {
    var url = Config.backend + "/api/Donvi/getpxgialai?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setXa(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getloaihinhvantaitheodonvi = () => {
    var url =
      Config.backend +
      "/api/Donvi/getdvvttheoid?dvvt_id=" +
      donvi_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) {
          let defaultloai = [];
          data.map((row) => {
            defaultloai.push({
              id: row.loaihinhvantai_id,
              ten: row.loaihinhvantai,
            });
          });
          setLoaihinhvalue(defaultloai);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhatdonvi = () => {
    capnhattrangthai();
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var ngaygpkd =
        ngaycapgpdkkd.$y +
        "-" +
        String(ngaycapgpdkkd.$M + 1).padStart(2, "0") +
        "-" +
        ngaycapgpdkkd.$D;
      var ngaygpkdvt =
        ngaycapgpkdvt.$y +
        "-" +
        String(ngaycapgpkdvt.$M + 1).padStart(2, "0") +
        "-" +
        ngaycapgpkdvt.$D;
      var ngayhethan = "";
      if (ngayhethangpkdvt) {
        ngayhethan =
          ngayhethangpkdvt.$y +
          "-" +
          String(ngayhethangpkdvt.$M + 1).padStart(2, "0") +
          "-" +
          ngayhethangpkdvt.$D;
      }
      let loaihinhvantai = [];
      loaihinhvalue.map((row) => {
        loaihinhvantai.push({ id: row.id });
      });
      var url = Config.backend + "/api/Donvi/capnhatdvvt";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: donvi_id,
          tendonvi: tendonvi,
          diachidonvi: diachidonvi,
          phuongxa_id: xavalue.id,
          sonha: sonha,
          sodienthoai: sodienthoai,
          giayphepdkkd: giayphepdkkd,
          ngaycapgpdkkd: ngaygpkd,
          coquancap: coquancap,
          nguoidaidien: nguoidaidien,
          sogiayphep: sogiayphep,
          ngaycapgpkdvt: ngaygpkdvt,
          ngayhethangpkdvt: ngayhethan,
          nguoidieuhanh: nguoidieuhanh,
          loaihinhvantai: loaihinhvantai,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const capnhattrangthai = () => {
    var url = Config.backend + "/api/Donvi/capnhatdvvt_trangthaihoatdong";
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: donvi_id,
        hoatdong: hoatdong,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateCapnhat = () => {
    // Kiem tra ngay cap GPDKVT va ngay het han GPDKVT
    if (ngayhethangpkdvt) {
      if (isLessThanDay(ngayhethangpkdvt, ngaycapgpkdvt)) {
        return Error.ER0001;
      }
    }
    // Kiem tra cac truong bat buoc nhap
    if (tendonvi.trim() === "") {
      return Error.ER0002;
    }
    if (!xavalue || xavalue === 0) {
      return Error.ER0004;
    }
    if (loaihinhvalue.length == 0) {
      return Error.ER0005;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getloaihinhvantaitheodonvi();
    getdonvitheoid();
    getloaihinhvantai();
    getxaphuong();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Tên đơn vị"
                value={tendonvi}
                variant="outlined"
                size="small"
                onChange={(event) => {
                  setTendonvi(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số nhà, thôn, xóm"
                variant="outlined"
                value={sonha}
                size="small"
                onChange={(event) => {
                  setSonha(event.target.value);
                  if (event.target.value) {
                    setDiachidonvi(event.target.value + ", " + xaten);
                  }
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={xa}
                value={xavalue}
                getOptionLabel={(option) => option.ten}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, value) => {
                  setXavalue(value);
                  setXaten(value.ten);
                  setDiachidonvi(sonha + ", " + value.ten);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setXavalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn Phường/Xã"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                value={diachidonvi}
                size="small"
                disabled
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginTop: "1px" }}>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={sodienthoai}
                onChange={(event) => {
                  setSodienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số GPĐKKD"
                variant="outlined"
                size="small"
                value={giayphepdkkd}
                onChange={(event) => {
                  setGiayphepdkkd(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp GPĐKKD"
                  value={ngaycapgpdkkd}
                  onChange={(newValue) => {
                    setNgaycapgpdkkd(newValue);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "37px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Cơ quan cấp GPĐKKD"
                variant="outlined"
                size="small"
                value={coquancap}
                onChange={(event) => {
                  setCoquancap(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Người đại diện"
                variant="outlined"
                value={nguoidaidien}
                size="small"
                onChange={(event) => {
                  setNguoidaidien(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số GPĐKVT"
                variant="outlined"
                value={sogiayphep}
                size="small"
                onChange={(event) => {
                  setSogiayphep(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp GPĐKVT"
                  value={ngaycapgpkdvt}
                  onChange={(newValue) => {
                    setNgaycapgpkdvt(newValue);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "37px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày hết hạn GPĐKVT (không thời hạn thì để trống)"
                  value={ngayhethangpkdvt}
                  onChange={(newValue) => {
                    setNgayhethangpkdvt(newValue);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "37px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Người điều hành"
                variant="outlined"
                value={nguoidieuhanh}
                size="small"
                onChange={(event) => {
                  setNguoidieuhanh(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl
              variant="outlined"
              size="small"
              style={{ width: "100%", marginTop: "8px" }}
            >
              <InputLabel id="hoatdong-label">Trạng thái hoạt động</InputLabel>
              <Select
                labelId="hoatdong-label"
                value={hoatdong}
                onChange={(event) => {
                  setHoatdong(event.target.value);
                }}
                label="Trạng thái hoạt động"
                style={{ height: "35px" }}
              >
                <MenuItem value={1}>Hoạt động</MenuItem>
                <MenuItem value={2}>Tạm ngưng</MenuItem>
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginTop: "10px" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                multiple
                freeSolo
                disableClearable
                size="small"
                value={loaihinhvalue}
                options={loaihinhvantai}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.ten || ""}
                onChange={(event, newValue) => {
                  setLoaihinhvalue(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn loại hình vận tải"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        //height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhatdonvi}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatdonvi.propTypes = {
  donvi_id: PropTypes.number,
};
export default Capnhatdonvi;
